module.exports = __webpack_public_path__ + "static/img/xuanzhongtupian.png@2x.6749bf69.png";